import React from 'react'
import { Link } from 'react-router-dom'
import { XCircle } from '@phosphor-icons/react'

export default function CheckoutCancelPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div
        className="w-14 h-14 bg-ds-elevated border border-ds-border flex items-center justify-center mb-6"
        style={{ borderRadius: 2 }}
      >
        <XCircle size={32} weight="fill" className="text-ds-muted" />
      </div>
      <h1 className="type-h2 text-ds-text text-2xl mb-2">Pago cancelado</h1>
      <p
        className="text-ds-muted text-sm max-w-sm mb-8"
        style={{ fontFamily: 'Barlow, sans-serif' }}
      >
        No hay problema — puedes actualizar cuando quieras.
      </p>
      <Link to="/pricing" className="btn-accent">
        Ver planes
      </Link>
    </div>
  )
}
